import React from "react";

const SettingsPage = () => {
  return (
    <div>
      <h1>Configurações</h1>
      <p>Ajuste as preferências do sistema aqui.</p>
    </div>
  );
};

export default SettingsPage;
